export function parseDateForInput(value: string | undefined | null): string {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  const match = trimmed.match(/^\d{4}-\d{2}-\d{2}/);

  return match ? match[0] : trimmed.split(/[T\s]/)[0] || "";
}

export function parseTimeForInput(value: string | undefined | null): string {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  const compact = trimmed.match(/^(\d{3,4})-/);

  if (compact) {
    const digits = compact[1].padStart(4, "0");
    const hh = digits.slice(0, 2);
    const mm = digits.slice(2, 4);

    return `${hh}:${mm}`;
  }
  const ampm = trimmed.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)$/i);

  if (ampm) {
    let h = parseInt(ampm[1], 10);
    const m = ampm[2] ?? "00";
    const period = ampm[3].toLowerCase();

    if (period === "pm" && h < 12) h += 12;
    if (period === "am" && h === 12) h = 0;
    return `${String(h).padStart(2, "0")}:${m}`;
  }
  const match = trimmed.match(/(\d{1,2}):(\d{2})/);

  if (match) {
    const hh = match[1].padStart(2, "0");
    const mm = match[2];

    return `${hh}:${mm}`;
  }
  return "";
}
